import { render, staticRenderFns } from "./SkippedAssignmentsWarning.vue?vue&type=template&id=6a562503"
import script from "./SkippedAssignmentsWarning.vue?vue&type=script&lang=js"
export * from "./SkippedAssignmentsWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports